export const black = '#000'

export const white = '#fff'

export const light = {
  50: '#F7F7F8',
  100: '#EFEFF0',
  200: '#E7E7E9',
  300: '#E0DFE2',
  400: '#CBC9CF',
  500: '#ABA9B1',
  600: '#96949E',
  700: '#79738C',
  800: '#545062',
  900: '#24222A',
} as const

export const orange = {
  100: '#FFF5EC',
  200: '#FFECD9',
  300: '#FFE2C6',
  400: '#FFAF5E',
  500: '#FFA142',
  600: '#D88837',
  700: '#472C12',
  800: '#33200D',
  900: '#1F1308',
} as const

export const green = {
  100: '#EAFAEE',
  200: '#D5F5DE',
  300: '#C0F0CE',
  400: '#4DD474',
  500: '#2ECD5C',
  600: '#27AE4E',
  700: '#0C3919',
  800: '#092912',
  900: '#05180A',
} as const

export const purple = {
  100: '#F1EEFA',
  200: '#E4DEF6',
  300: '#D6CEF1',
  400: '#8D74D9',
  500: '#795CD3',
  600: '#664EB3',
  700: '#22193B',
  800: '#18122A',
  900: '#0E0B19',
} as const

export const red = {
  100: '#FEEEF0',
  200: '#FDDEE1',
  300: '#FCCCD2',
  400: '#F77180',
  500: '#F6586A',
  600: '#D14A5A',
  700: '#44181D',
  800: '#311115',
  900: '#1C0A0C',
} as const

export const zipPrimary = {
  A50: '#411361', // represents action
  A100: '#1A0826',
  100: '#EDE6FF',
  200: '#DBCCFF',
  300: '#C9B3FF',
  400: '#AA8FFF',
  500: '#6542BE',
  600: '#503498',
  700: '#20153D',
  800: '#18102E',
  900: '#100A1F',
} as const
